import React from "react";
var __jsx = React.createElement;
import Headline from './Headline';
import RichText from './RichText';
function Column(_ref) {
  var className = _ref.className,
    yextInfo = _ref.yextInfo,
    headlineFieldId = _ref.headlineFieldId,
    textFieldId = _ref.textFieldId;
  return __jsx("div", {
    className: "nva-banner__bottom-column ".concat(className)
  }, __jsx(Headline, {
    className: "nva-banner__bottom-headline u-h6 u-mt-0 u-mb-3",
    yextInfo: yextInfo,
    fieldId: headlineFieldId,
    skeletonData: {
      className: 'u-mb-3',
      width: 'min(18ch, 100%)',
      type: 'h6'
    }
  }), __jsx(RichText, {
    className: "nva-banner__bottom-text",
    yextInfo: yextInfo,
    fieldId: textFieldId,
    skeletonData: {
      width: 'min(60ch, 100%)',
      height: '6ch',
      type: 'body2'
    }
  }));
}
export default Column;